class ResetServiceDefault {
    constructor(ResetServiceApi, toastr, ModalService) {
        this.ResetServiceApi = ResetServiceApi;
        this.toastr = toastr;
        this.ModalService = ModalService;
    }
    resetTestExecutionTraces(userId, simId, suiteId, successCallBack) {
        this.deleteTestSuiteRecords('Delete Traces', 'This will delete all traces for all test runs, including all verdicts. This cannot be undone.', 'Delete', 'Cancel', () => this.ResetServiceApi.suiteTests(userId, simId, suiteId), successCallBack);
    }
    resetTestCaseVerdicts(userId, simId, suiteId, successCallBack) {
        this.deleteTestSuiteRecords('Clear Test Case Verdicts', 'This will keep all traces for all test runs but hide the verdicts, allowing you to quickly see the verdicts of all tests in the library. This cannot be undone.', 'Clear', 'Cancel', () => this.ResetServiceApi.testCaseVerdicts(userId, simId, suiteId), successCallBack);
    }
    deleteTestSuiteRecords(headerText, bodyText, actionButtonText, closeButtonText, deleteAction, successCallBack) {
        const modalOptions = {
            actionButtonText: actionButtonText,
            closeButtonText: closeButtonText,
            headerText: headerText,
            bodyText: bodyText
        };
        this.ModalService
            .showModal({}, modalOptions)
            .then(() => {
            deleteAction().then(() => {
                this.toastr.info(`'${headerText}' operation succeeded`);
                successCallBack();
            });
        }, () => { this.toastr.info(`'${headerText}' operation cancelled`); });
    }
}
angular.module('app').factory('ResetService', (ResetServiceApi, toastr, ModalService) => {
    return new ResetServiceDefault(ResetServiceApi, toastr, ModalService);
});
